import { render, staticRenderFns } from "./SalonStylistReviewComplete.vue?vue&type=template&id=5f203c33&scoped=true"
import script from "./SalonStylistReviewComplete.vue?vue&type=script&lang=js"
export * from "./SalonStylistReviewComplete.vue?vue&type=script&lang=js"
import style0 from "./SalonStylistReviewComplete.vue?vue&type=style&index=0&id=5f203c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f203c33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions})
